import React, { useContext, useRef } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { ProgressSpinner } from "primereact/progressspinner";
import {
  genElNumber,
  genElText,
  genElTextArea,
  genElZirvuFileManager,
} from "../components/utils/EditorDialogElementGenerator";
import { FaImage } from "react-icons/fa6";
import { format } from "date-fns";
import getExtensionFromMime from "../utils/GetExtensionFromMime";
import useAPIFileManagerRequest from "../custom_hooks/simple/useAPIFileManagerRequest";
import UiContext from "../store/ui-context";

const editTitle = "Edit Kategori";
const addTitle = "Tambah Kategori";

const EditProdukKategoriDialog = (props) => {
  const {
    visible,
    onHide,
    onConfirm,
    loading,
    title,
    data,
    setData,
    addNewMode,
    error,
    setError,
  } = props;

  const {
    requestGet: requestGetFM,
    requestGetOne: requestGetOneFM,
    requestPost: requestPostFM,
    requestDelete: requestDeleteFM,
    loading: loadingFM,
  } = useAPIFileManagerRequest();

  const fileInputRef = useRef(null);
  const uiContext = useContext(UiContext);

  /**
   * Validates the form data.
   *
   * @returns {boolean} - Returns true if the data is valid, otherwise false.
   * @returns {object} - Returns an object containing the error messages, format { field: message}.
   */
  const validate = () => {
    let valid = true;
    let newEror = {};

    if (!valid) setError(newEror);

    return valid;
  };

  const saveImage = async ({ file }) => {
    // const blob = base64ToBlob(base64Image);
    const mimeType = file.type; // eg: image/png
    const fileExtension = getExtensionFromMime(mimeType);

    const folderName = format(new Date(), "yyyy-MM-dd");
    const fileName = `image-file-${format(new Date(), "HH-mm")}-${Math.ceil(
      Math.random() * 1000
    )}.${fileExtension}`;

    const _file = new File([file], fileName, { type: mimeType });
    // const file = new File([blob], fileName, { type: "image/jpeg" });
    const formData = new FormData();
    formData.append("file", _file);
    formData.append("folder_name", folderName);

    requestPostFM({
      fullUrl: `/api/file/addfilespecial`,
      formBody: formData,
      isForm: true,
      onError: ({ message, data }) => {
        uiContext.showErrorMsg("Error", message);
      },
      onSuccess: ({ data, message }) => {
        const url = data.url;
        if (url) {
          setData((prevData) => ({
            ...prevData,
            gambar: url,
          }));
        }
      },
    });
  };

  // handle UI event section

  const handleUploadImage = (event) => {
    const file = event.target.files[0];
    if (file) {
      saveImage({ file });
    }
  };

  /**
   * Generate Dialog Form Element
   *
   * various function to generate
   *
   * genElText({ field, name, data, setData, disabled, autoFocus, error })
   * genElTextPassword({ field, name, data, setData, disabled, autoFocus, error })
   * genElTextDropdown({ field, name, data, setData, options, disabled, autoFocus, error, optionLabel = "name" })
   * genElNumber({ field, name, data, setData, min_fraction_digits, max_fraction_digits, min, max, disabled, autoFocus, error })
   * genElNumberDropdown({ field, name, data, setData, options, disabled, autoFocus, error, optionLabel = "name" })
   * genElBoolean({ field, name, data, setData, labelTrue = "Ya", labelFalse = "Tidak", disabled, autoFocus, error })
   * genElDate({ field, name, data, setData, primeFormat, min, max, showTime, time, month, year, disabled, autoFocus, error })
   * genElObject({ field, name, value, onClick, selectorGenerator, disabled, autoFocus, error })
   */

  const elNama = genElText({
    field: "nama",
    name: "Nama",
    data,
    setData,
    error,
  });
  const elIndex = genElNumber({
    field: "index",
    name: "Index",
    data,
    setData,
    error,
  });

  const ImageButton = ({ className, placeholder, icon, onClick, image }) => {
    return (
      <div
        className={`col-center-center ${className} border-dashed border-slate-200 border-2 gap-2 hover:bg-stone-100 active:bg-stone-100 cursor-pointer p-1`}
        onClick={(e) => {
          if (onClick) onClick(e);
        }}
      >
        {!image && (
          <div className={`col-center-center gap-2`}>
            <FaImage className="text-slate-300 text-5xl" />
            <span className="text-lg font-semibold text-slate-300">
              {" "}
              {placeholder ?? ""}{" "}
            </span>
          </div>
        )}
        {image && (
          <img
            src={image}
            alt={`gambar-${placeholder}`}
            className="object-cover w-full h-full"
          />
        )}
      </div>
    );
  };

  const dialogFooter = (
    <React.Fragment>
      <Button
        label="Cancel"
        icon="pi pi-times"
        outlined
        onClick={props.onHide}
      />
      <Button
        label="Save"
        icon="pi pi-check"
        onClick={(e) => {
          const valid = validate();
          if (valid) {
            onConfirm(data);
          }
        }}
      />
    </React.Fragment>
  );

  return (
    <Dialog
      visible={visible}
      style={{ width: "45rem" }}
      breakpoints={{ "960px": "75vw", "641px": "90vw" }}
      header={addNewMode ? addTitle : editTitle}
      modal
      className={`p-fluid`}
      footer={dialogFooter}
      onHide={onHide}
    >
      <div className="col-start-center relative h-100">
        <div className={`row-start-start w-100 gap-3`}>
          <div className="col-start-start w-100 gap-3">
            {elNama}
            {elIndex}
            <div className="col-start-start w-full gap-1">
              <span className="text-sm font-bold text-slate-500">Gambar</span>
              <input
                type="file"
                accept="image/*"
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={(event) => handleUploadImage(event)}
              />
              <ImageButton
                className="w-full min-h-[10rem]"
                image={data.gambar}
                onClick={() => {
                  fileInputRef.current.click();
                }}
              />
            </div>
          </div>
        </div>
        {loading && (
          <div
            className={`col-center-center w-100  gap-2 absolute z-100 h-100 bg-black/20 rounded `}
          >
            <ProgressSpinner />
          </div>
        )}
      </div>
    </Dialog>
  );
};

export default EditProdukKategoriDialog;
